export default __webpack_public_path__ + "static/media/success.90c7cd05.gif";